import { ArrowRight } from 'lucide-react';

import type { SiteContent } from '../../content/types';
import { Card, CardContent } from '../ui/card';
import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';

interface ProcessSectionProps {
  content: SiteContent;
}

export function ProcessSection({ content }: ProcessSectionProps): JSX.Element {
  return (
    <section className="py-12 sm:py-16">
      <Container className="space-y-8">
        <SectionHeading title={content.processSection.headline} />
        <div className="grid gap-4 lg:grid-cols-3">
          {content.processSection.steps.map((step, index) => (
            <Card key={step.title} className="relative h-full bg-white">
              <CardContent className="flex h-full flex-col gap-3 p-6">
                <p className="text-base font-semibold text-[color:var(--color-text)]">{step.title}</p>
                <p className="text-sm leading-relaxed text-[color:var(--color-muted)]">{step.text}</p>
                {index < content.processSection.steps.length - 1 ? (
                  <ArrowRight className="absolute right-4 top-4 hidden h-4 w-4 text-[color:var(--color-primary)] lg:block" />
                ) : null}
              </CardContent>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
